import { importHighcharts } from '@/lib/highcharts'
import { BlockModule } from '../common'
import { countTo, doIfInViewOrDefer, chartLineColors } from './common'
import { getMarketDataForeignExInterbankSwap } from '@/api'
import { defineComponent } from 'vue'
import ChartShareButtons from '@/components/website/ChartShareButtons.vue'

new BlockModule({
    selector: '.block-market-data-foreign-ex-interbank-swap',
    vueComponent: defineComponent({
        components: { ChartShareButtons },
        setup() {},
    }),
    async setupBlock(el, onTeardown, blockContext) {
        const chartData = await getMarketDataForeignExInterbankSwap()

        const setupChart = async () => {
            const chartEl = el.querySelector('.chart-container')
            if (!chartEl) return

            const Highcharts = await importHighcharts()

            const chart = Highcharts.chart({
                chart: {
                    type: 'line',
                    renderTo: chartEl as HTMLElement,
                    marginTop: 40,
                },
                title: {
                    text: '',
                },
                xAxis: {
                    lineColor: '#DBDBDB',
                    allowDecimals: false,
                },

                yAxis: {
                    color: '#DBDBDB',
                    title: {
                        text: 'Volume (USD mil)',
                        align: 'high',
                        rotation: 0,
                        reserveSpace: false,
                        textAlign: 'left',
                        y: -20,
                    },
                    labels: {
                        formatter: function (): string {
                            return (this.value as number) / 1000 + 'M'
                        },
                    },
                },
                series: chartData.map((x, index) => ({
                    name: x.category,
                    type: 'line',
                    color: chartLineColors[index],
                    data: x.data,
                })),
                exporting: {
                    enabled: false,
                    filename: 'foreign-ex-interbank-swap',
                },
                responsive: {
                    rules: [
                        {
                            condition: {
                                maxWidth: 1024,
                            },
                            chartOptions: {
                                legend: {
                                    align: 'center',
                                    verticalAlign: 'bottom',
                                },
                            },
                        },
                    ],
                },
                tooltip: {
                    valueDecimals: 2,
                },
            })

            const download = el.querySelector<HTMLButtonElement>('.download-btn')
            if (download) {
                download.addEventListener('click', () => {
                    chart.downloadCSV()
                })
            }

            onTeardown(() => {
                chart.destroy()
            })
        }

        doIfInViewOrDefer(() => {
            setupChart()
        }, blockContext)
    },
})
